module.exports = __webpack_public_path__ + "img/remindAlert.7e5d258a.png";